import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "component-variable__values" };
import { computed, toRef } from "vue";
import ComponentVariableValue from "./value/ComponentVariableValue.vue";
import { useComponentVariableMutable } from "src/shared/store/component-mutable/composables/useComponentVariableMutable";
import { useCampaignWorkingVariants } from "../composables/useCampaignWorkingVariants";
import { useCampaignVariants } from "src/shared/store/campaign-built/composables/useCampaignVariants";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableValues',
    props: {
        componentId: {},
        campaignId: {},
        variableName: {},
        componentMutableKey: {},
        variantDisplayMode: {}
    },
    setup(__props) {
        const props = __props;
        const { componentVariableMutable } = useComponentVariableMutable(toRef(props, "componentMutableKey"), toRef(props, "variableName"));
        const { defaultVariant } = useCampaignVariants(toRef(props, "campaignId"));
        const { workingVariants } = useCampaignWorkingVariants(toRef(props, "campaignId"));
        const filteredWorkingVariants = computed(() => {
            if (!componentVariableMutable.value || !defaultVariant.value) {
                return [];
            }
            if (componentVariableMutable.value.isTranslatable() ||
                componentVariableMutable.value.isMultiVariant()) {
                return workingVariants.value;
            }
            return [defaultVariant.value];
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredWorkingVariants.value, (variant) => {
                    return (_openBlock(), _createBlock(ComponentVariableValue, {
                        key: variant,
                        "variable-name": props.variableName,
                        "component-mutable-key": props.componentMutableKey,
                        variant: variant,
                        "variant-display-mode": _ctx.variantDisplayMode
                    }, null, 8 /* PROPS */, ["variable-name", "component-mutable-key", "variant", "variant-display-mode"]));
                }), 128 /* KEYED_FRAGMENT */))
            ]));
        };
    }
});
